// UI
export const HEADER_HEIGHT = 50 // must match client/src/scss/_variables.scss

// Auth
export const AUTH_TIMEOUT = 8000
export const AUTH_OFFLINE_ERROR_MSG = 'You are offline'

// Routes
export const SCENE_ROUTE = 'scene'
